import { h } from 'preact'
import Panel from '../panel'
import TeamNotesMetadata from './TeamNotesMetadata'
import TeamNotesButtons from './TeamNotesButtons'
import Textarea from '../ui-components/Textarea'
import classNames from 'classnames'

type Props = {
  contentInTextarea: string,
  isLoading: boolean,
  updatedBy: string,
  updatedAt: string,
  onContentChange: (value: string) => void,
  onTextareaFocus: () => void,
  onSaveChanges: () => void,
  onCancel: () => void,
  showButtons: boolean
}

const TeamNotesPanel = ({ contentInTextarea, isLoading, updatedBy, updatedAt, onContentChange, onTextareaFocus, onSaveChanges, onCancel, showButtons } : Props) => (
  <Panel collapsible title='Team notes'>
    <TeamNotesMetadata
      updatedBy={updatedBy}
      updatedAt={updatedAt}
      isLoading={isLoading}
    />
    <Textarea
      class={classNames(
        'form-control',
        'team-notes__textarea',
        { 'is-loading': isLoading }
      )}
      placeholder='Leave a note to your moderation team'
      maxLength={1000}
      onContentChange={onContentChange}
      onTextareaFocus={onTextareaFocus}
      value={contentInTextarea}
    />
    {showButtons
      ? <TeamNotesButtons
        isLoading={isLoading}
        onSaveChanges={onSaveChanges}
        onCancel={onCancel}
      />
      : null
    }
  </Panel>
)

export default TeamNotesPanel
